import { useErrorSnack } from './useErrorSnack';
import './ErrorDlg.css';

/**
 * ErrorDlg — modal error dialog driven by ErrorEngine.
 * Replaces ErrorSnack — more visible, Jerny style.
 * Does not auto-close — user must explicitly dismiss.
 * If multiple errors are queued, dismissing one shows the next.
 * Mount once at app root level.
 */
export default function ErrorDlg() {
    const { error, dismiss } = useErrorSnack();

    if (!error) return null;

    return (
        <div id="error-dlg-backdrop" className="error-dlg-backdrop">
            <div id="error-dlg-card" className="error-dlg-card">
                <div id="error-dlg-header" className="error-dlg-header">
                    <span className="error-dlg-title">⚠ Error</span>
                    <button
                        className="error-dlg-close"
                        // stopPropagation — prevent backdrop or card animation interfering with click
                        onClick={(e) => {
                            //
                            e.stopPropagation();
                            dismiss();
                        }}
                    >
                        ✕
                    </button>
                </div>
                <div id="error-dlg-source" className="error-dlg-source">
                    {error.source}
                </div>
                <div id="error-dlg-message" className="error-dlg-message">
                    {error.message}
                </div>
            </div>
        </div>
    );
}
